import type { ImpressumStrings } from "../../types";

export const impressum: ImpressumStrings = {
  title: "Impressum",
  sections: [
    {
      title: "依据《数字服务法》(DDG) 第 5 条的信息",
      paragraphs: [
        { pre: true, nodes: ["0-AI UG (haftungsbeschränkt)\nNeckartalstraße 127\n70376 Stuttgart\n德国"] },
      ],
    },
    {
      title: "代表人",
      paragraphs: [
        { pre: true, nodes: ["管理人员：\nPaul Willi Patrick Horn\nAnton Leo Rudolf Horn"] },
      ],
    },
    {
      title: "联系方式",
      paragraphs: [{ nodes: ["电子邮件：contact@cero-ai.com"] }],
    },
    {
      title: "登记信息",
      paragraphs: [
        { pre: true, nodes: ["商业登记簿登记\n登记法院：Amtsgericht Stuttgart\n登记号：登记中"] },
      ],
    },
    {
      title: "增值税识别号",
      paragraphs: [
        { pre: true, nodes: ["依据《增值税法》第 27a 条 (§ 27a UStG) 的增值税识别号：\n申请中"] },
      ],
    },
    {
      title: "依据《媒体国家协议》第 18 条第 2 款 (§ 18 (2) MStV) 对内容负责",
      paragraphs: [
        { pre: true, nodes: ["Paul Willi Patrick Horn\nNeckartalstraße 127\n70376 Stuttgart"] },
      ],
    },
    {
      title: "争议解决",
      paragraphs: [
        {
          nodes: [
            "欧盟委员会提供在线争议解决 (ODR) 平台：",
            { link: "ec.europa.eu/consumers/odr", href: "https://ec.europa.eu/consumers/odr/" },
          ],
        },
        {
          nodes: [
            "我们没有意愿也没有义务参加消费者仲裁机构的争议解决程序。",
          ],
        },
      ],
    },
  ],
};
